module.exports = __webpack_public_path__ + "static/floor-2-c5d2d0f48f13a21ca92baa43b6b058b2.png";